import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "self-center cursor-pointer" };
const _hoisted_3 = { class: "q-pl-xs" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "row q-ml-xs" };
import { computed } from "vue";
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { useAccountStore } from "src/stores/account";
import { useCentralStore } from "src/stores/central";
import { useViewStore } from "src/stores/view";
import appMultiColoredIcon from "src/components/icon/appMultiColoredIcon.vue";
import searchBrowseBtn from "src/layouts/components/header/searchBrowseBtn.vue";
import verificationAndDelBtn from "src/layouts/components/header/verificationAndDelBtn.vue";
import { defineComponent } from "vue";
const __default__ = defineComponent({
    name: 'mobile-header'
});
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    setup(__props) {
        const $q = useQuasar();
        const accountStore = useAccountStore();
        const centralStore = useCentralStore();
        const viewStore = useViewStore();
        const drawer = computed({
            get: () => viewStore.drawer,
            set: (newValue) => {
                if (newValue) {
                    $q.sessionStorage.set("openingChat", true);
                }
                viewStore.toggleDrawer(newValue);
            },
        });
        const unreadNotifications = computed(() => {
            return accountStore.unreadNotifications;
        });
        const unread = computed(() => {
            return accountStore.unreadChat;
        });
        const user = computed(() => accountStore.user);
        const isOnline = computed(() => centralStore.online);
        /**
         * Toggle open / close drawer
         * @param type drawer type
         */
        function toggleDrawer(type) {
            drawer.value = !drawer.value;
            if (type) {
                viewStore.toggleDrawerTab(type);
            }
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_q_icon = _resolveComponent("q-icon");
            const _component_q_badge = _resolveComponent("q-badge");
            const _component_q_btn = _resolveComponent("q-btn");
            const _component_q_toolbar = _resolveComponent("q-toolbar");
            return (_openBlock(), _createBlock(_component_q_toolbar, { class: "mobile-padding full-width row justify-between" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_router_link, {
                            to: { name: 'Search' },
                            class: "self-center",
                            "aria-label": "Go Home"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(appMultiColoredIcon, {
                                        icon: (_ctx.$route.name || '').toString().toLowerCase().includes('propert') ? 'getproperty' : 'getspaces',
                                        "icon-size": 28
                                    }, null, 8, ["icon"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(searchBrowseBtn, {
                            "btn-bind": {
                                round: true,
                                dense: true,
                                flat: true,
                                size: '20px',
                                icon: 'apps'
                            },
                            "main-menu-offset": [47, 0],
                            class: "self-center"
                        }, {
                            button: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_q_icon, {
                                        name: "apps",
                                        size: "32px"
                                    })
                                ])
                            ]),
                            _: 1
                        }),
                        _withDirectives(_createVNode(_component_q_icon, {
                            name: "wifi_off",
                            size: "32px",
                            color: "grey-6",
                            class: "q-ml-sm self-center"
                        }, null, 512), [
                            [_vShow, !isOnline.value]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(verificationAndDelBtn, { "btn-class": {
                                'hide-lt-340': true
                            } }),
                        _withDirectives(_createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_router_link, { to: { name: 'Notifications' } }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                        flat: "",
                                        round: "",
                                        dense: "",
                                        class: _normalizeClass(["mobile-header-margin", {
                                                'text-primary': _ctx.$route.name === 'Notifications',
                                                'grey8-white-text-color': _ctx.$route.name !== 'Notifications'
                                            }]),
                                        icon: "notification_important",
                                        "aria-label": "Notifications Drawer",
                                        "data-cy": "user-menu-drawer"
                                    }, {
                                        default: _withCtx(() => [
                                            _withDirectives(_createVNode(_component_q_badge, {
                                                color: "red",
                                                "text-color": "white",
                                                floating: ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(unreadNotifications.value > 9 ? '9+' : unreadNotifications.value), 1)
                                                ]),
                                                _: 1
                                            }, 512), [
                                                [_vShow, unreadNotifications.value > 0]
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["class"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_router_link, { to: { name: 'Inbox' } }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                        round: "",
                                        dense: "",
                                        flat: "",
                                        class: _normalizeClass(["mobile-header-margin", {
                                                'text-primary': _ctx.$route.name === 'Inbox',
                                                'grey8-white-text-color': _ctx.$route.name !== 'Inbox'
                                            }]),
                                        icon: "message",
                                        "aria-label": "Chat Drawer",
                                        "data-cy": "user-menu-drawer"
                                    }, {
                                        default: _withCtx(() => [
                                            _withDirectives(_createVNode(_component_q_badge, {
                                                color: "red",
                                                "text-color": "white",
                                                floating: ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(unread.value > 9 ? '9+' : unread.value), 1)
                                                ]),
                                                _: 1
                                            }, 512), [
                                                [_vShow, unread.value > 0]
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["class"])
                                ]),
                                _: 1
                            })
                        ], 512), [
                            [_vShow, user.value]
                        ]),
                        _createVNode(_component_q_btn, {
                            flat: "",
                            round: "",
                            dense: "",
                            class: "mobile-header-user grey8-white-text-color",
                            icon: "menu",
                            "aria-label": "Drawer",
                            "data-cy": "user-menu-drawer",
                            id: "header-menu-drawer",
                            onClick: toggleDrawer
                        }, {
                            default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_q_badge, {
                                    color: "red",
                                    "text-color": "white",
                                    floating: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                            name: "priority_high",
                                            color: "white",
                                            size: "12px"
                                        })
                                    ]),
                                    _: 1
                                }, 512), [
                                    [_vShow, user.value && !user.value.email_validated]
                                ])
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _: 1
            }));
        };
    }
});
